import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
function setCookie (cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}
function getCookie (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
  }
  return "";
}
const store = new Vuex.Store({
  state: {
    count: getCookie('userInfo'),
    token: getCookie('userToken'),
    RecentRecharge: getCookie('RecentRechargeList') ? getCookie('RecentRechargeList') : []
  },
  mutations: {
    login (state, res) {
      setCookie('userInfo', JSON.stringify(res.data.userInfo));
      setCookie('userToken', res.data.userToken);
      state.token = res.data.userToken;
      state.count = res.data.userInfo;
    },
    RecentRechargeList (state, data) {
      setCookie('RecentRechargeList', JSON.stringify(data));
      state.RecentRecharge = data
    },
    logout (state) {
      document.cookie = 'userInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'userToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'RecentRechargeList=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      state.RecentRecharge = [];
      state.token = null;
      state.count = null;
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js